import { createGlobalStyle } from 'styled-components';

export const FileBrowserStyles = createGlobalStyle`
    div.rendered-react-keyed-file-browser div.action-bar {
        margin-bottom: 8px;
        flex-wrap: wrap;
        display: flex;
        align-items: flex-start;
    }
    div.rendered-react-keyed-file-browser div.action-bar input[type='search'] {
        display: block;
        flex-grow: 2;
        min-width: 300px;
        padding: 4px 8px;
        line-height: 13px;
        margin-bottom: 8px;
        border: 2px solid;
        border-color: ${(props) => props.theme.palette.fileBrowser.borderColor};
    }
    div.rendered-react-keyed-file-browser div.action-bar .item-actions {
        margin: 0;
        padding: 0;
        margin-top: 10px;
        display: none;
    }
    div.rendered-react-keyed-file-browser div.action-bar ul.item-actions {
        display: block;
        flex-grow: 1;
        min-width: 300px;
        margin-left: 10px;
        white-space: nowrap;
    }
    div.rendered-react-keyed-file-browser div.action-bar ul.item-actions li {
        display: inline-block;
        margin: 0;
    }
    div.rendered-react-keyed-file-browser div.action-bar ul.item-actions li a {
        color: ${(props) => props.theme.palette.fileBrowser.linkColor};
        text-transform: uppercase;
    }
    div.rendered-react-keyed-file-browser
        div.action-bar
        ul.item-actions
        li:not(:last-child) {
        margin-right: 8px;
    }

    div.rendered-react-keyed-file-browser div.files table {
        width: 100%;
        margin-bottom: 24px;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }
    div.rendered-react-keyed-file-browser div.files table th,
    div.rendered-react-keyed-file-browser div.files table td {
        font-weight: normal;
        text-align: left;
        margin: 0;
        padding: 8px;
    }
    div.rendered-react-keyed-file-browser div.files table th {
        font-weight: 600;
    }
    div.rendered-react-keyed-file-browser div.files table th.size,
    div.rendered-react-keyed-file-browser div.files table th.modified,
    div.rendered-react-keyed-file-browser div.files table td.size,
    div.rendered-react-keyed-file-browser div.files table td.modified,
    div.rendered-react-keyed-file-browser div.files table th.actions,
    div.rendered-react-keyed-file-browser div.files table td.actions {
        text-align: right;
    }
    div.rendered-react-keyed-file-browser div.files table th.name i,
    div.rendered-react-keyed-file-browser div.files table td.name i {
        padding-right: 8px;
    }
    div.rendered-react-keyed-file-browser div.files table thead th {
        border-bottom: 2px solid;
        border-bottom-color: ${(props) =>
            props.theme.palette.fileBrowser.borderColor};
    }
    div.rendered-react-keyed-file-browser div.files table tr:not(:last-child) td {
        border-bottom: 2px solid;
        border-bottom-color: ${(props) =>
            props.theme.palette.fileBrowser.fileBrowser};
    }
    div.rendered-react-keyed-file-browser div.files table td.name {
        padding-left: 11px;
    }
    div.rendered-react-keyed-file-browser div.files table td.name form.renaming {
        display: flex;
        align-items: center;
    }
    div.rendered-react-keyed-file-browser div.files table td.name form.renaming i {
        flex-grow: 0;
        flex-shrink: 0;
    }
    div.rendered-react-keyed-file-browser
        div.files
        table
        td.name
        form.renaming
        input[type='text'] {
        flex: 1;
    }
    div.rendered-react-keyed-file-browser div.files table tr td {
        cursor: pointer;
    }
    div.rendered-react-keyed-file-browser div.files table tr.selected td {
        font-weight: 600;
    }
    div.rendered-react-keyed-file-browser div.files table tr.selected td input,
    div.rendered-react-keyed-file-browser div.files table tr.selected td button {
        font-weight: normal;
    }
    div.rendered-react-keyed-file-browser div.files table tr.selected td.name {
        position: relative;
    }
    div.rendered-react-keyed-file-browser
        div.files
        table
        tr.selected
        td.name:after {
        content: ' ';
        position: absolute;
        left: 0;
        top: 0;
        width: 4px;
        height: 100%;
        background: ${(props) =>
            props.theme.palette.fileBrowser.borderHighlight};
    }

    div.rendered-file-browser div.files li.file.selected > div.item,
    div.rendered-file-browser div.files li.folder.selected > div.item {
        color: ${(props) => props.theme.palette.fileBrowser.itemColor};
        background: ${(props) =>
            props.theme.palette.fileBrowser.itemBackgroundColor};
    }
    div.rendered-file-browser div.files li.file.selected > div.item .text-muted,
    div.rendered-file-browser div.files li.folder.selected > div.item .text-muted {
        color: ${(props) => props.theme.palette.fileBrowser.borderColor};
    }
    div.rendered-file-browser div.files li.file.selected > div.item a:not(.btn),
    div.rendered-file-browser
        div.files
        li.file.selected
        > div.item.folder
        a:not(.btn),
    div.rendered-file-browser div.files li.file.selected > div.item i,
    div.rendered-file-browser div.files li.folder.selected > div.item a:not(.btn),
    div.rendered-file-browser
        div.files
        li.folder.selected
        > div.item.folder
        a:not(.btn),
    div.rendered-file-browser div.files li.folder.selected > div.item i {
        color: ${(props) => props.theme.palette.fileBrowser.itemColor};
    }

    div.rendered-file-browser div.files ul {
        list-style: none;
        padding: 0;
        display: grid;
        gap: 4px;
        grid-template-columns: repeat(3, 1fr);
    }
    div.rendered-file-browser div.files ul li.folder {
        grid-column: 1/4;
    }
    div.rendered-file-browser div.files ul li.folder > div.item {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding-left: 4px;
        border: 1px solid;
        border-color: ${(props) => props.theme.palette.fileBrowser.fileBrowser};
    }
    div.rendered-file-browser div.files ul li.folder > div.item span.name {
        flex: 1;
        line-height: folder-size;
    }
    div.rendered-file-browser div.files ul li.folder > div.item span.thumb {
        flex-basis: 45px;
        border: none;
        text-align: center;
    }
    div.rendered-file-browser div.files ul li.folder > div.item span.thumb > i {
        line-height: 45px;
        font-size: 16px;
    }
    div.rendered-file-browser div.files ul li.folder > div.item form.renaming {
        margin-top: 8px;
        margin-right: 8px;
    }
    div.rendered-file-browser div.files ul li.folder > p {
        margin: 8px;
        margin-bottom: 0;
        padding: 0;
    }
    div.rendered-file-browser div.files ul li.folder.expanded {
        padding-bottom: 8px;
        border-bottom: 1px solid;
        border-bottom-color:${(props) =>
            props.theme.palette.fileBrowser.fileBrowser};
        border-left: 4px solid;
        border-left-color: ${(props) =>
            props.theme.palette.fileBrowser.fileBrowser};
        border-right: 1px solid;
        border-right-color: ${(props) =>
            props.theme.palette.fileBrowser.fileBrowser};
    }
    div.rendered-file-browser div.files ul li.folder.expanded > div.item {
        padding-left: 0px;
        margin-right: -1px;
        margin-left: -1px;
    }
    div.rendered-file-browser div.files ul li.folder.expanded.selected {
        border-bottom: 1px solid;
        border-bottom-color: ${(props) =>
            props.theme.palette.fileBrowser.fileBrowserSelected};
        border-left: 4px solid;
        border-left-color: ${(props) =>
            props.theme.palette.fileBrowser.fileBrowserSelected};
        border-right: 1px solid;
        border-right-color: ${(props) =>
            props.theme.palette.fileBrowser.fileBrowserSelected};
    }
    div.rendered-file-browser div.files ul li.selected.folder > div.item {
        border: 1px solid;
        border-color: ${(props) =>
            props.theme.palette.fileBrowser.fileBrowserSelected};
    }
    div.rendered-file-browser
        div.files
        ul
        li.selected.folder
        > div.item
        span.thumb {
        border: none;
    }
    div.rendered-file-browser div.files ul li.file {
        margin: 4px;
        padding: 0;
    }
    div.rendered-file-browser div.files ul li.file > div.item {
        display: flex;
        flex-direction: column;
        padding: 4px;
        margin: 0;
    }
    div.rendered-file-browser div.files ul li.file > div.item span.thumb {
        flex-basis: 120px;
        text-align: center;
        position: relative;
        border: 1px solid;
        border-color: ${(props) => props.theme.palette.fileBrowser.fileBrowser};
        margin-bottom: 10px;
    }
    div.rendered-file-browser div.files ul li.file > div.item span.thumb > i {
        font-size: 35px;
        line-height: 120px;
    }
    div.rendered-file-browser div.files ul li.file > div.item span.thumb div.image {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: 50% 50%;
        background-repeat: no-repeat;
    }
    div.rendered-file-browser div.files ul li.selected.file > div.item span.thumb {
        border: 1px solid;
        border-color: ${(props) =>
            props.theme.palette.fileBrowser.fileBrowserSelected};
    }
    div.rendered-file-browser
        div.files
        ul
        li.selected.file
        > div.item
        span.thumb
        div.image {
        opacity: 0.8;
    }

    div.rendered-file-browser p.loading,
    div.rendered-file-browser p.empty {
        margin: 16px 0;
    }

    div.rendered-react-keyed-file-browser div.files table th,
    div.rendered-react-keyed-file-browser div.files table td a {
        color: ${(props) => props.theme.palette.fileBrowser.tableLink};
    }

    div.rendered-react-keyed-file-browser div.files table th:hover,
    div.rendered-react-keyed-file-browser div.files table td a:hover {
        color: ${(props) => props.theme.palette.fileBrowser.tableHover};
        border-bottom: 1px solid;
        border-bottom-color: ${(props) =>
            props.theme.palette.fileBrowser.tableHover};
    }

    div.rendered-react-keyed-file-browser div.files table th,
    div.rendered-react-keyed-file-browser
        div.files
        table
        td
        a:not([href]):not([class]) {
        color: inherit;
        border: none;
    }

    div.rendered-react-keyed-file-browser div.files table th.name i,
    div.rendered-react-keyed-file-browser div.files table td.name svg {
        margin-right: 4px;
        margin-bottom: 4px;
    }
`;
